import axios from 'axios'
import { setFilterValues, setFormValues, toggleFilterValues } from '../../modules/mutations'
import { castAttributesForCamelCase, castAttributesForSnakeCase } from '../../modules/string_converter'
import { i18n } from '../../plugins/i18n'
import generateRandomStr from '../../modules/generateRandomStr'

const initialStateData = () => ({
  id: undefined,
  name: '',
  gmbCategoryId: '',
  services: [],
  storeUuids: []
})

const findIndexById = (services) => (id) => {
  return services.findIndex(service => {
    if (service.id == undefined) return false
    return id === service.id
  })
}

export const companiesServicePattern = {
  namespaced: true,
  state: {
    data: initialStateData(),
    formValues: {
      stores: []
    },
    loading: false,
  },
  getters: {
    storeTotalCount(state) {
      return state.formValues.stores.length
    },
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    apiFailure(state) {
      state.loading = false
    },
    initServicePattern(state) {
      state.data = initialStateData()
    },
    readServicePattern(state, payload) {
      const data = payload.data
      data.services = data.items.map(item => {
        item.id = generateRandomStr(1000)
        return item
      })
      delete data.items
      state.data = castAttributesForCamelCase(data)
      state.formValues.stores = [...state.data.storeUuids]
      state.loading = false
    },
    upsertLocalService(state, payload) {
      const index = findIndexById(state.data.services)(payload.id)
      if (index === -1) {
        state.data.services.push(payload)
      } else {
        state.data.services.splice(index, 1, payload)
      }
    },
    deleteLocalService(state, payload) {
      const index = findIndexById(state.data.services)(payload)
      state.data.services.splice(index, 1)
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues
  },
  actions: {
    setFormValues({ commit }, payload) {
      commit('setFormValues', payload)
    },
    initServicePattern({ commit }) {
      commit('initServicePattern')
    },
    upsertLocalService({ commit }, payload) {
      commit('upsertLocalService', payload)
    },
    deleteLocalService({ commit }, payload) {
      commit('deleteLocalService', payload)
    },
    createServicePattern({ commit, rootState }, payload) {
      commit('prepareConnect')

      return axios.post(`/api/companies/${rootState.route.params.company_uuid}/service_patterns`, castAttributesForSnakeCase({
        servicePattern: payload
      }))
        .then(res => {
          commit('readServicePattern', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.servicePatterns.modelName') }) }, { root: true })
        })
        .catch(e => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: e.response.data.errors[0].detail }, { root: true })
          throw e
        })
    },
    updateServicePattern({ commit, rootState }, payload) {
      commit('prepareConnect')

      return axios.put(`/api/companies/${rootState.route.params.company_uuid}/service_patterns/${rootState.route.params.id}`, castAttributesForSnakeCase({
        servicePattern: payload
      }))
        .then(res => {
          commit('readServicePattern', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.servicePatterns.modelName') }) }, { root: true })
        })
        .catch(e => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: e.response.data.errors[0].detail }, { root: true })
          throw e
        })
    },
    readServicePattern({ commit, rootState }, id) {
      commit('prepareConnect')

      return axios.get(`/api/companies/${rootState.route.params.company_uuid}/service_patterns/${id}`)
        .then(res => {
          commit('readServicePattern', res.data)
        })
        .catch(e => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: e.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
